export default "__VITE_ASSET__CACYnjWc__"